/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AsCodeFieldReferenceDto } from './AsCodeFieldReferenceDto';

export type AsCodeFieldExpressionDto = {
    field: AsCodeFieldReferenceDto;
    kind: AsCodeFieldExpressionDto.kind;
};

export namespace AsCodeFieldExpressionDto {

    export enum kind {
        FIELD = 'field',
        VALUE = 'value',
    }


}
